import instaplayAPI from '../../services/api/instaplays'
import _ from 'lodash'
import {getInstaplaysState} from "@/store/States";
import {instaplayUTCToLocal} from "@/services/time";

const state = getInstaplaysState()

function findById(id, instaplays) {
    for (let i = 0; i < instaplays.length; i++)
        if (id === instaplays[i].InstaplayId)
            return i
    return -1
}

function setTimeStamp(instaplay) {
    instaplay.timeStamp = `${instaplay.InstaplayId}-${new Date().getTime()}`
}

const getters = {
    isLoading: state => mode => state.status[mode] === 'loading',
    count: state => mode => state.count[mode],
    isPlayLoading: state => state.playStatus.status === 'loading',
    isSuccess: state => mode => state.status[mode] === 'success',
    isPlaySuccess: state => state.playStatus.status === 'success',
    isError: state => state.status === 'error',
    isPlayError: state => state.playStatus.status === 'error',
    instaplays: state => state.instaplays,
    completedPlays: state => state.completedPlays,
    isThereMoreActive: state => state.toFetch['active'] < state.count['active'],
    isThereMoreCurrent: state => state.toFetch['current'] < state.count['current'],
    isThereMoreCompleted: state => state.toFetch['completed'] < state.count['completed'],
    isThereMore: state => mode => state.toFetch[mode] < state.count[mode],
}

const actions = {
    async fetchUserIDs({commit, rootState, dispatch, getters}, mode) {
        if (getters.isLoading(mode)) return
        commit('loading', mode)

        let response
        try {
            response = await instaplayAPI.fetchUserInstaplayIDs(rootState.auth.user.token, mode)
        } catch (e) {
            return commit('error', mode)
        }
        const success = response.Success

        if (success === 1) {
            let instaplays = response.InstaplayID || response.InstaplayId
                || await dispatch('setPlayIds', response.activeUserInstaplays)
                || await dispatch('setPlayInfo', response.completedUserInstaplays)
            // if (mode === 'manage') instaplays.reverse()
            let addition = _.difference(instaplays, state.instaplayIDs[mode])
            let removal = _.difference(state.instaplayIDs[mode], instaplays)
            if (removal.length) {
                for (let i = 0; i < removal.length; i++) {
                    commit('moveInstaplay', {from: mode, id: removal[i]})
                }
            }
            if (addition.length) {
                let ids = {
                    mode: mode,
                    ids: addition,
                    count: response.count
                }
                commit('pushIDs', ids)
                commit('success', mode)
                let to = mode === 'completed' ? 'pushInstaplay' : 'unshiftInstaplay'
                dispatch('loadMoreInstaplays', {mode, to, count: addition.length})

            } else {
                commit('success', mode)
            }
        } else {
            commit('error', mode)
        }
    },

    async playInstaplay({commit, rootState}, data) {
        commit('playLoading')

        data['token'] = rootState.auth.user.token
        const id = data.InstaplayId
        let response
        try {
            response = await instaplayAPI.playInstaplay(data)
        } catch (e) {
            return commit('playError', 'Something went wrong!')
        }

        if (response.Success) {
            commit('auth/updateScoins', response.user.scoins, {root: true})
            commit('setNewPlayId', {id, playid: response.playid})
            commit('updateInstaplay', {
                id,
                mode: 'current',
                winSCoins: response.Instaplay.winSCoins,
                numplayers: response.numplayers,
                queued: response.queued
            })
            commit('moveInstaplay', {id, from: 'current', to: 'active'})
            commit('playSuccess')
        } else {
            if (response.Error)
                commit('playError', response.Message)
        }
    },

    async modifyPlay({state, commit, rootState}, data) {
        commit('playLoading')

        const id = data.InstaplayId
        const l = state.activePlayIds[id].length

        data['token'] = rootState.auth.user.token
        data['playid'] = state.activePlayIds[id][l - 1]

        let response
        try {
            response = await instaplayAPI.modifyPlay(data)
        } catch (e) {
            return commit('playError', 'Something went wrong!')
        }

        if (response.Success) {
            commit('auth/updateScoins', response.user.scoins, {root: true})
            commit('setNewPlayId', {id, playid: response.playid})
            commit('updateInstaplay', {
                id,
                mode: 'active',
                winSCoins: data.winSCoins,
                numplayers: response.numplayers,
                queued: response.queued
            })
            commit('updateUserPlay', {
                id,
                selected: data.selectedContestantName || data.yesORno || data.overORunder,
                risked: data.riskedSCoins
            })
            commit('playSuccess')
        } else {
            if (response.Error)
                commit('playError', response.Message)
        }
    },

    async deletePlay({commit, rootState}, id) {
        commit('playLoading')

        const l = state.activePlayIds[id].length

        const data = {
            token: rootState.auth.user.token,
            playid: state.activePlayIds[id][l - 1]
        }

        let response
        try {
            response = await instaplayAPI.deletePlay(data)
        } catch (e) {
            return commit('playError', 'Something went wrong!')
        }

        if (response.Success) {
            commit('auth/updateScoins', response.user.scoins, {root: true})
            commit('updateInstaplay', {
                id,
                mode: 'active',
                winSCoins: response.Instaplay.winSCoins,
                numplayers: response.numplayers,
                queued: response.queued
            })
            commit('moveInstaplay', {id, from: 'active', to: 'current'})
            commit('playSuccess')
        } else {
            if (response.Error)
                commit('playError', response.Message)
        }
    },

    loadMoreInstaplays({state, commit, dispatch, rootState, getters}, {mode, to = 'pushInstaplay', count=5}) {
        let maxCount;
        maxCount = count <= 5 ? count : 5
        if (getters.isLoading(mode)) return
        commit('loading', mode)
        let i
        let promises = []
        for (i = state.toFetch[mode]; i < state.count[mode] && i < maxCount + state.toFetch[mode]; i++) {
            if (state.instaplayIDs[mode][i])
                promises.push(
                    instaplayAPI.getInstaplayUsingID(state.instaplayIDs[mode][i])
                )
            if (mode.startsWith('manage')) {
                dispatch('getInstaplayOutcome', {
                    token: rootState.auth.user.token,
                    InstaplayID: state.instaplayIDs[mode][i]
                })
            }
        }
        Promise.all(promises).then(instaplays => {
            let userids = []
            let fails = 0
            for (let i = 0; i < instaplays.length; i++) {
                if (!state.instaplayIDs[mode].includes(instaplays[i].InstaplayId)) {
                    fails += 1
                    continue
                }
                commit(to, {mode: mode, instaplay: instaplays[i]})
                userids.push(instaplays[i].gameMaster.userid)
                if (instaplays[i].InstaplayType === 'pool')
                    dispatch('getPoolBalance', instaplays[i].InstaplayId)
            }
            dispatch('thumbnails/getThumbnails', userids, {root: true})
            commit('updateToFetch', {mode, i, fails})
            commit('success', mode)
        }).catch(() => {
            commit('error', mode)
        })
    },

    async declareWinner({dispatch, commit, rootState}, {payload, mode}) {
        commit('loading', 'declare')

        payload['token'] = rootState.auth.user.token
        let response
        try {
            response = await instaplayAPI.declareWinner(payload)
        } catch (e) {
            return commit('error', 'declare')
        }
        if (response.Success) {
            commit('auth/deltaScoins', response.GMdeltaSCoins, {root: true})
            await dispatch('getThumbsList', response)
            commit('setDeclareWinnerResult', {InstaplayId: payload.InstaplayId, result: response, payload})
            commit('setDeclareWinnerDate', {mode, id: payload.InstaplayId, date: new Date()})
            // commit('moveInstaplayToTheEnd', {mode: 'manage', id: payload.InstaplayId})
            commit('success', 'declare')
        } else {
            commit('error', 'declare')
        }           
    },

    async getInstaplayOutcome({commit, dispatch}, payload) {
        commit('loading', 'declare')

        let response
        try {
            response = await instaplayAPI.getInstaplayOutcome(payload)
        } catch (e) {
            return commit('error', 'declare')
        }
        if (response.Success) {
            commit('setDeclareWinnerResult', {InstaplayId: payload.InstaplayID, result: response})
            dispatch('getThumbsList', response)
            commit('success', 'declare')
        } else {
            commit('error', 'declare')
        }
    },

    async getPoolBalance({commit, rootState}, id) {
        const params = {
            token: rootState.auth.user.token,
            InstaplayId: id
        }
        let response
        try {
            response = await instaplayAPI.getPoolBalance(params)
        } catch (e) {
            return
        }
        if (response.Success) {
            commit('setPoolBalance', {id, scoins: response.scoins})
        }
    },

    async openCloseInstaplay({commit, rootState}, {id, val, mode}) {
        commit('loading', 'edit')

        const params = {
            token: rootState.auth.user.token,
            InstaplayId: id
        }

        let response
        try {
            response = await instaplayAPI.openCloseInstaplay(params, val)
        } catch (e) {
            return commit('error', 'edit')
        }
        if (response.Success) {
            commit('changeInstaplayStatus', {id, status: val, mode})
            commit('success', 'edit')
        } else {
            commit('error', 'edit')
        }
    },

    async markFavoriteInstaplay({commit, state}, {id, val}) {
        commit('loading', 'edit')

        // const params = {
        //     token: rootState.auth.user.token,
        //     InstaplayId: id
        // }
        //
        // let response
        // try {
        //     response = await instaplayAPI
        // } catch (e) {
        //     return commit('error', 'edit')
        // }
        // if (response.Success) {
        commit('changeInstaplayFavorite', {id, val, mode: state.mode})
        commit('success', 'edit')
        // } else {
        //     commit('error', 'edit')
        // }
    },

    async deleteInstaplay({commit, rootState}, {id, mode}) {
        commit('loading', 'edit')

        const params = {
            token: rootState.auth.user.token,
            InstaplayId: id
        }

        let response
        try {
            response = await instaplayAPI.deleteInstaplay(params)
        } catch (e) {
            return commit('error', 'edit')
        }
        if (response.Success) {
            commit('moveInstaplay', {from: mode, id})
            commit('success', 'edit')
        } else {
            commit('error', 'edit')
        }


    },

    async getThumbsList({dispatch}, response) {
        let userids = []
        if (response.winnerList)
            userids = userids.concat(response.winnerList)
        if (response.loserList)
            userids = userids.concat(response.loserList)
        if (response.tieList)
            userids = userids.concat(response.tieList)
        if (userids.length) {
            let list = []
            for (let user of userids)
                list.push(Object.keys(user)[0])
            dispatch('thumbnails/getThumbnails', list, {root: true})
        }
    },

    setPlayIds({state}, playIds) {
        if (!playIds) return
        let instaplayIds = []
        for (let i = 0; i < playIds.length; i++) {
            const obj = playIds[i]
            const playIdList = Object.keys(obj.playid)
            state.activePlayIds[obj.InstaplayId] = playIdList
            const lastPlay = obj.playid[playIdList[playIdList.length - 1]]
            let userPlay = {
                selected: lastPlay.selectedContestantName ||
                    lastPlay.yesORno ||
                    lastPlay.overORunder || JSON.parse(lastPlay.bracket),
                risked: lastPlay.riskedSCoins
            }
            state.userPlays[obj.InstaplayId] = userPlay
            instaplayIds.push(obj.InstaplayId)
        }
        return instaplayIds
    },

    setPlayInfo({state}, playInfo) {
        state.completedPlays = playInfo
        let keys = Object.keys(playInfo)
        for (let key of keys) {
            instaplayUTCToLocal(playInfo[key])
        }
        let ids = []
        keys.forEach(x => ids.push(parseInt(x)))
        return ids.reverse()
    },

    getSelections({state, rootState}) {
        let set = JSON.parse(localStorage.getItem('selections'))
        if (set)
            if (set.userid === rootState.auth.user.userid) {
                Object.assign(state.userPlays, set)
                return
            }

        Object.assign(state.userPlays, {
            userid: rootState.auth.user.userid
        })
        localStorage.removeItem('selections')

    }
}

const mutations = {
    resetState(state) {
        Object.assign(state, getInstaplaysState())
    },
    moveInstaplay(state, {id, from, to}) {
        const iID = state.instaplayIDs[from].indexOf(id)
        if (iID === -1) return
        state.instaplayIDs[from].splice(iID, 1)
        state.count[from] -= 1
        state.toFetch[from] -= 1

        const iInst = findById(id, state.instaplays[from])
        if (iInst === -1) return
        const inst = state.instaplays[from].splice(iInst, 1)[0]

        if (to) {
            state.instaplayIDs[to].unshift(id)
            state.instaplays[to].unshift(inst)
            state.count[to] += 1
            state.toFetch[to] += 1
        }
    },
    pushIDs(state, data) {
        for (let i = data.ids.length - 1; i >= 0; i--)
            state.instaplayIDs[data.mode].splice(state.toFetch[data.mode], 0, parseInt(data.ids[i]))
        state.count[data.mode] = data.count
    },
    setNewPlayId(state, data) {
        if (!state.activePlayIds[data.id])
            state.activePlayIds[data.id] = []

        state.activePlayIds[data.id].push(data.playid)
    },
    setDeclareWinnerResult(state, data) {
        if (data.payload) data.result['submit'] = data.payload
        state.instaplayOutcome[data.InstaplayId] = data.result
    },
    updateInstaplay(state, data) {
        const iInst = findById(data.id, state.instaplays[data.mode])
        if (iInst === -1) return
        if (data.numplayers !== undefined)
            state.instaplays[data.mode][iInst]["numplayers"] = data.numplayers
        if (data.queued !== undefined)
            state.instaplays[data.mode][iInst]["queued"] = data.queued
        if (data.winSCoins !== undefined) {
            const type = state.instaplays[data.mode][iInst].InstaplayType
            state.instaplays[data.mode][iInst][type]["winSCoins"] = data.winSCoins
        }
    },
    updateUserPlay(state, data) {
        let userPlay = state.userPlays[data.id]
        if (userPlay) {
            userPlay.selected = data.selected
            userPlay.risked = data.risked
        }
    },
    pushInstaplay(state, data) {
        setTimeStamp(data.instaplay)
        instaplayUTCToLocal(data.instaplay)
        state.instaplays[data.mode].push(data.instaplay)
    },
    unshiftInstaplay(state, data) {
        setTimeStamp(data.instaplay)
        instaplayUTCToLocal(data.instaplay)
        state.instaplays[data.mode].unshift(data.instaplay)
    },
    moveInstaplayToTheEnd(state, data) {
        const iInst = findById(data.id, state.instaplays[data.mode])
        let instaplay = state.instaplays[data.mode].splice(iInst, 1)[0]
        state.instaplays[data.mode].push(instaplay)
    },
    removeInstaplay(state, data) {
        const iInst = findById(data.id, state.instaplays[data.mode])
        state.instaplays[data.mode].splice(iInst, 1)
    },
    updateToFetch(state, data) {
        state.toFetch[data.mode] = (data.i - data.fails)
        state.count[data.mode] -= data.fails
    },
    loading(state, mode) {
        state.status[mode] = 'loading'
    },
    playLoading(state) {
        state.playStatus.status = 'loading'
    },
    success(state, mode) {
        state.status[mode] = 'success'
    },
    playSuccess(state) {
        state.playStatus.status = 'success'
    },
    error(state, mode) {
        state.status[mode] = 'error'
    },
    playError(state, message) {
        state.playStatus.status = 'error'
        state.playStatus.message = message
        state.playStatus.alert = true
    },
    setPlayAlert(state, val) {
        state.playStatus.alert = val
        if (!val)
            state.playStatus.message = ''
    },
    setMode(state, mode) {
        state.mode = mode
    },
    setDeclareWinnerDate(state, {mode, id, date}) {
        const iInst = findById(id, state.instaplays[mode])
        let dateObj = {
            declareYear: date.getFullYear(),
            declareMonth: date.getMonth(),
            declareDay: date.getDate(),
            declareHour: date.getHours(),
            declareMinute: date.getMinutes(),
            declareSecond: date.getSeconds(),
        }
        Object.assign(state.instaplays[mode][iInst], dateObj)
        setTimeStamp(state.instaplays[mode][iInst])
    },
    changeInstaplayStatus(state, {id, status, mode}) {
        const iInst = findById(id, state.instaplays[mode])
        state.instaplays[mode][iInst].status = status === 'close' ? 'closed' : 'current'
    },
    changeInstaplayFavorite(state, {id, val, mode}) {
        const iInst = findById(id, state.instaplays[mode])
        state.instaplays[mode][iInst].favorite = val
    },
    setPoolBalance(state, data) {
        const pool = {}
        pool[data.id] = data.scoins
        state.poolBalance = {...state.poolBalance, ...pool}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
